import { render, staticRenderFns } from "./ModelDiv.vue?vue&type=template&id=798b83a8&scoped=true&"
import script from "./ModelDiv.vue?vue&type=script&lang=js&"
export * from "./ModelDiv.vue?vue&type=script&lang=js&"
import style0 from "./ModelDiv.vue?vue&type=style&index=0&id=798b83a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "798b83a8",
  null
  
)

export default component.exports